var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIntegrationFilled(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.89713 17.2057C9.89713 18.9571 8.41675 20.3841 6.59993 20.3841C4.78311 20.3841 3.30273 18.9571 3.30273 17.2057C3.30273 15.4544 4.78311 14.0273 6.59993 14.0273C8.41675 14.0273 9.89713 15.4544 9.89713 17.2057Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M20.714 6.77799C20.714 8.52934 19.2336 9.95637 17.4168 9.95637C15.6 9.95637 14.1196 8.52934 14.1196 6.77799C14.1196 5.02664 15.6 3.59961 17.4168 3.59961C19.2336 3.59961 20.714 5.02664 20.714 6.77799Z",
    fill: "currentColor"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M11.9661 17.8216L15.2633 21L16.5418 19.7676L14.7755 18.0649H17.7026C19.5194 18.0649 20.9998 16.6379 20.9998 14.8865V11.7081H19.1998V14.8865C19.1998 15.6811 18.5269 16.3298 17.7026 16.3298H14.7755L16.5418 14.627L15.2633 13.3946L11.9661 16.573C11.6129 16.9135 11.6129 17.4649 11.9661 17.8054V17.8216Z",
    fill: "currentColor"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M3 9.0973V12.2757H4.8V9.0973C4.8 8.3027 5.4729 7.65405 6.2972 7.65405H9.2243L7.45794 9.35676L8.73645 10.5892L12.0336 7.41081C12.3869 7.07027 12.3869 6.51892 12.0336 6.17838L8.73645 3L7.45794 4.23243L9.2243 5.93514H6.2972C4.48037 5.93514 3 7.36216 3 9.11351V9.0973Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIntegrationFilled);
export default __webpack_public_path__ + "static/media/integration_filled.79d3b4a08525d85319ae4c66027c52f7.svg";
export { ForwardRef as ReactComponent };